import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-web-page',
  templateUrl: './footer-web-page.component.html',
  styleUrls: ['./footer-web-page.component.scss']
})
export class FooterWebPageComponent {

}
